import { render } from "./MyStudentsRecodDataTable.vue?vue&type=template&id=545e08a4"
import script from "./MyStudentsRecodDataTable.vue?vue&type=script&lang=js"
export * from "./MyStudentsRecodDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__